/**
 * Handle the Wording Service.
 */
export class WordingService {
  /**
   * The default wording phrase.
   *
   * @type {string}
   */
  static defaultWordingPhrase = '__undefined__';

  /**
   * The default wording key.
   *
   * @type {number}
   */
  static defaultWordingKey = 503;

  /**
   * Get dict.
   *
   * @type {object}
   */
  static dict = {};

  /**
   * Set the dictionnary of the options.
   *
   * @param   {opts} opts - The dictionnary to set.
   */
  static setDictionnary(opts) {
    /**
     * The dictionnary of wording.
     *
     * @type {object}
     */
    WordingService.dict = opts || {};
  }

  /**
   * Get the wording in fuction of - - - the key.
   *
   * @param   {string} key - The key.
   * @returns {string}     The wording.
   */
  static getWording(key) {
    const defaultWordingKeyToSet = WordingService.dict[WordingService.defaultWordingKey]
      ? WordingService.dict[WordingService.defaultWordingKey]
      : WordingService.defaultWordingPhrase;

    return WordingService.dict[key] ? WordingService.dict[key] : defaultWordingKeyToSet;
  }

  /**
   * Set the wording in fuction of the key and value.
   *
   * @param {string} key -   - The key.
   * @param {string} value - The value.
   */
  static setWording(key, value) {
    WordingService.dict[key] = value;
  }
}
